import React from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import DashboardHeader from '../DashboardHeader'
import ProfileForm from '../../../Component/ProfileForm'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Profile = (props) => {
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    return (
        <>
            <SEOTAG page="Profile" />
            <Layout props={props}>
                {isVarifiedGfTheme ? (
                    <div className="GFdashWrapperContainer">
                        <DashboardHeader />
                        <Container className="dashboard-wrapper">
                            <Grid container spacing={3}>
                                <ProfileForm buyerOnly={1} phone_country_code_must={1} />
                            </Grid>
                        </Container>
                    </div>
                ) : (
                    <>
                        <DashboardHeader />
                        <Container className="dashboard-wrapper">
                            <Grid container spacing={3}>
                                <ProfileForm buyerOnly={1} phone_country_code_must={1} />
                            </Grid>
                        </Container>
                    </>
                )}
            </Layout>
        </>
    )
}

export default Profile
